import type { GLSelectOptions } from '@group-link-one/gl-components';
import GLLogo from '../../CreateFlow/Images/logo.svg';

export interface SignatureFormData {
  nome: string;
  position: string;
  phone: string;
  email: string;
  image: string;
  buCategory: string;
}

export interface BuCategoryOption {
  id: string;
  label: string;
  value: string;
}

export const BU_CATEGORY_OPTIONS: GLSelectOptions[] = [
  { id: '1', text: 'Group Link One', value: 'group_link_one' },
  { id: '2', text: 'Group Link Two', value: 'group_link_two' },
  { id: '3', text: 'Group Link Three', value: 'group_link_three' },
];

export interface BuConfig {
  displayName: string;
  signatureLogo: string;
  website: string;
  tagline: string;
  socialMedia: {
    linkedin: string;
    instagram: string;
    youtube: string;
  };
}

export const BU_CONFIGS: Record<'group_link_one', BuConfig> = {
  group_link_one: {
    displayName: 'Group Link One',
    signatureLogo: GLLogo,
    website: 'www.grouplinkone.com',
    tagline: 'Welcome to the AIoT revolution',
    socialMedia: {
      linkedin: '/grouplinkone',
      instagram: '@grouplinkone',
      youtube: '/grouplinkone',
    },
  },
};
